import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { When } from "react-if";
import { RELOADING_ICON } from "../icons";
export default function Blocker(props) {
    return (_jsxs("div", { ...props, className: classNames(props.className, { blocked: props.blocking, unblocked: !props.blocking }), children: [props.children, _jsx(When, { condition: props.blocking, children: _jsx("div", { className: "spinner", children: _jsx(FontAwesomeIcon, { ...RELOADING_ICON, style: { fontSize: "4rem", } }) }) })] }));
}
